import { Checkbox as HCheckbox, Field as HField, Label } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/16/solid';
import { ReactNode } from 'react';

export interface CheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: ReactNode;
    disabled?: boolean;
}

export const Checkbox = ({ checked, onChange, label, disabled }: CheckboxProps) => (
    <HField disabled={disabled} className="flex min-h-control cursor-pointer items-center gap-3 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60">
        <HCheckbox
            checked={checked}
            onChange={onChange}
            className="group flex size-5 shrink-0 items-center justify-center rounded-md border-[1.5px] border-line-strong bg-surface data-[checked]:border-inverse data-[checked]:bg-inverse"
        >
            <CheckIcon className="hidden size-4 text-on-inverse group-data-[checked]:block" aria-hidden="true" />
        </HCheckbox>
        <Label className="cursor-pointer text-small text-strong">{label}</Label>
    </HField>
);
